import React from 'react'

import { IdGen } from 'utils'

import * as Tables from './tables'

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      const newState = [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
      return newState
    }
    case 'actualizar': {
      const newState = state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val = {
            ...val,
            ...action.payload
          }
        }
        return val
      })
      return newState
    }
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const DetallesSection = ({ innerDetalles, detallesRef }) => {
  const [detalles, detallesDispatcher] = React.useReducer(commonReducer, innerDetalles, inputArr => {
    if (inputArr) {
      return inputArr.map(x => {
        return {
          ...x,
          _idFila: IdGen.newId()
        }
      })
    }
    return []
  })

  React.useEffect(() => {
    detallesRef.current.getData = () => {
      return detalles
    }
  }, [detallesRef, detalles])

  return <Tables.TableDetalles detalles={detalles} dispatch={detallesDispatcher} />
}

export default React.memo(DetallesSection)
